import type { LocationHistoryMinimal } from '~hooks/useLocationHistory/models';
import {
  type JobSiteUsage,
  type LoadSiteUsage,
  type OrderSiteUsage,
} from '~hooks/useSiteUsages/models';

import DistanceMapDriverDay from './DistanceMapDriverDay';
import DistanceMapEntity from './DistanceMapEntity';
import DistanceMapOrder from './DistanceMapOrder';

export type GeoModel = 'jobs' | 'orders' | 'loads' | 'driver_days';

interface Props {
  model: GeoModel;
  modelId: string;
  companyId: string;
  siteUsages: (JobSiteUsage | OrderSiteUsage | LoadSiteUsage)[];
  pings: LocationHistoryMinimal[];
  isLoading: boolean;
}

export default function DistanceMap({
  model,
  modelId,
  companyId,
  siteUsages,
  pings,
  isLoading,
}: Props) {
  switch (model) {
    case 'jobs':
    case 'loads':
      return (
        <DistanceMapEntity
          companyId={companyId}
          jobId={model === 'jobs' ? modelId : undefined}
          siteUsages={siteUsages}
          pings={pings}
          isLoading={isLoading}
        />
      );
    case 'orders':
      return (
        <DistanceMapOrder
          orderId={modelId}
          companyId={companyId}
          siteUsages={siteUsages as OrderSiteUsage[]}
          pings={pings}
          isLoading={isLoading}
        />
      );
    case 'driver_days':
      return <DistanceMapDriverDay pings={pings} isLoading={isLoading} />;
  }
}
